import { useState, useEffect } from 'react'

import AssignmentToolbar from './assignmentToolbar'
import UnassignmentToolbar from './unassignmentToolbar'
import DeleteToolbar from './deleteToolbar'

import SaveViewToolbar from './saveViewToolbar'
import LoadViewToolbar from './loadViewToolbar'

import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from '@mui/x-data-grid-pro'

import { useGetCampaignsQuery } from '../../campaigns/slice'
import { useAssignProspectsToCampaignMutation } from '../slice'
import { useGetUsersQuery } from '../../users/slice'
import { useGetClientsQuery } from '../../clients/slice'

const CustomGridToolbar = ({ selectedIds }) => {
  const { data: campaigns } = useGetCampaignsQuery()
  const { data: users } = useGetUsersQuery()
  const { data: clients } = useGetClientsQuery()

  const [assignProspectsToCampaign] = useAssignProspectsToCampaignMutation()

  const [mappedRepresentatives, setMappedRepresentatives] = useState([])
  const [mappedProducers, setMappedProducers] = useState([])

  useEffect(() => {
    if (campaigns && users) {
      const mapped = campaigns.map((campaign) => {
        const representatives = campaign.representatives?.map((rep) => {
          const user = users.find((u) => u.sub === rep)
          if (user)
            return {
              id: user.sub,
              name: `${user.givenName} ${user.familyName}`,
            }
          // TODO: This means there is a representative that is not a user. This should not happen.
          // TODO: It is likely due to the original user being deleted.
          // TODO: Remove assignments from campaign prospects when a user is deleted.
          return {
            id: 'unknown',
            name: 'Unknown BDR',
          }
        })
        const blankRepresentative = [
          {
            id: 'unspecified',
            name: 'Unspecified BDR',
          },
        ]
        return {
          id: campaign.id,
          name: campaign.name,
          code: campaign.code,
          candidates: blankRepresentative.concat(representatives || []),
        }
      })
      setMappedRepresentatives(mapped)
    }
  }, [campaigns, users])

  useEffect(() => {
    if (campaigns && clients) {
      const mapped = campaigns.map((campaign) => {
        const client = clients.find((c) => c.id === campaign.client)
        const producers = campaign.producers?.map((producerId) => {
          const producer = client?.producers.find((p) => p.id === producerId)
          if (producer)
            return {
              id: producer.id,
              name: producer.name,
            }
          return {
            id: 'unknown',
            name: 'Unknown PRD',
          }
        })
        const blankProducer = [
          {
            id: 'unspecified',
            name: 'Unspecified PRD',
          },
        ]
        return {
          id: campaign.id,
          name: campaign.name,
          code: campaign.code,
          candidates: blankProducer.concat(producers || []),
        }
      })
      setMappedProducers(mapped)
    }
  }, [campaigns, clients])

  const handleAssignToCampaignRepresentative = async (campaignId, representativeId) => {
    await assignProspectsToCampaign({
      campaignId,
      userId: representativeId,
      prospectIds: selectedIds,
    })
  }

  const handleAssignToCampaignProducer = async (campaignId, producerId) => {
    await assignProspectsToCampaign({
      campaignId,
      producerId,
      prospectIds: selectedIds,
    })
  }

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarExport />
      <AssignmentToolbar
        label="BDR"
        selectedIds={selectedIds}
        mappedCandidates={mappedRepresentatives}
        handleAssignment={handleAssignToCampaignRepresentative}
      />
      <AssignmentToolbar
        label="PRD"
        selectedIds={selectedIds}
        mappedCandidates={mappedProducers}
        handleAssignment={handleAssignToCampaignProducer}
      />
      <UnassignmentToolbar selectedIds={selectedIds} campaigns={campaigns} />
      <DeleteToolbar selectedIds={selectedIds} />
      <SaveViewToolbar />
      <LoadViewToolbar />
    </GridToolbarContainer>
  )
}

export default CustomGridToolbar
